import React from 'react';
import PropTypes from 'prop-types';

import './graph.scss';

import labelsDatas from '../../../data/labelsDatas';
import likesDatas from '../../../data/likesDatas';

import MyResponsivePie from './MyResponsivePie';
import MyResponsiveBar from './MyResponsiveBar';

const Graph = ({ labelsStats, likesStats }) => {

  const labelsStatsByName = labelsStats.reduce((acc, stat) => {
    acc[stat.label] = stat.value;
    return acc;
  }, {});

  const pieData = labelsDatas.map((data) => ({
    ...data,
    value: labelsStatsByName[data.label] ?? 0,
  }));

  const barData = likesDatas.map((data, i) => ({
    ...data,
    picture: likesStats[i]?.name ?? data.picture,
    like: likesStats[i]?.value ?? 0,
  }));
  
  return (
    <>
      <div className="graphs">
        <h2 className="graphs-title">Little Stats</h2>
        <div className="custom-charts">
          <div className="custom-chart">
            <MyResponsivePie className="custom-chart-pie" data={pieData}/>
          </div>
          <div className="custom-chart">
            <MyResponsiveBar data={barData}/>
          </div>
        </div>
      </div>
    </>
  );
  
};

/* Graph.propTypes = {
  labels: PropTypes.arrayOf.isRequired,
  pictures: PropTypes.arrayOf.isRequired,
}; */

export default Graph;
